<template>
  <v-container>
    <v-row no-gutters>
      <v-col
        cols="12"
        md="10"
        xl="10"
      >
        <v-text-field
          v-model="search"
          class="pl-7"
          placeholder="Search By Task Content"
          append-icon="search"
          label="Search Task"
          hide-no-data
          hide-selected
          clearable
        />
      </v-col>
      <v-spacer />
      <v-col
        cols="12"
        md="1"
        xl="1"
        align-self="center"
      >
        <v-tooltip
          content-class="bottom"
          bottom
        >
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              v-on="on"
              @click="loadAllTasks"
            >
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>Reload</span>
        </v-tooltip>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        cols="12"
        class="py-0 d-flex"
      >
        <p class="font-weight-bold font-17 my-auto pr-2">
          Filters:
        </p>
        <v-chip-group
          v-model="statusFilterId"
          mandatory
          active-class="deep-purple--text text--accent-4"
          column
        >
          <v-chip
            v-for="item in status"
            :key="item.id"
            outlined
            :value="item.id"
          >
            {{ item.name }}
          </v-chip>
        </v-chip-group>
      </v-col>
    </v-row>

    <v-data-table
      :headers="allTaskHeader"
      :loading="loading"
      height="370px"
      hide-default-footer
      class="all-task-table"
      :items="allTasks"
    >
      <template v-slot:item.content="{ item }">
        <div>
          <span
            :class="{
              'two-lines ellipse profile-content-width':isProfileTab,
              'two-lines ellipse approval-content-width':!isProfileTab
            }"
          >
            {{ item.content }}
          </span>
        </div>
      </template>

      <template v-slot:item.owner.person.name="{ item }">
        <div>
          <span
            :class="{
              'two-lines ellipse profile-name-width':isProfileTab,
              'two-lines ellipse approval-name-width':!isProfileTab
            }"
          >
            {{ item.owner.person.name }}
          </span>
        </div>
      </template>

      <template v-slot:item.assignee_names="{ item }">
        <div>
          <span
            :class="{
              'two-lines ellipse profile-name-width':isProfileTab,
              'two-lines ellipse approval-name-width':!isProfileTab
            }"
          >
            {{ item.assignee_names }}
          </span>
        </div>
      </template>

      <template v-slot:item.viewer_names="{ item }">
        <div>
          <span
            :class="{
              'two-lines ellipse profile-name-width':isProfileTab,
              'two-lines ellipse approval-name-width':!isProfileTab
            }"
          >
            {{ item.viewer_names }}
          </span>
        </div>
      </template>

      <template v-slot:item.task_status.name="{ item }">
        <div>
          <span
            :class="{
              'warning--text two-lines ellipse profile-status-width': (item.task_status.id === 100 && isProfileTab) || (item.task_status.id === 100 && !isProfileTab),
              'green--text two-lines ellipse profile-status-width': (item.task_status.id === 199 && isProfileTab) || (item.task_status.id === 199 && !isProfileTab),
              'black--text two-lines ellipse profile-status-width': (item.task_status.id === 200 && isProfileTab) || (item.task_status.id === 200 && !isProfileTab),
              'red--text two-lines ellipse profile-status-width':(item.task_status.id === 501 && isProfileTab) || (item.task_status.id === 501 && !isProfileTab),
            }"
          >
            {{ item.task_status.name }}
          </span>
        </div>
      </template>

      <template v-slot:item.priority.name="{ item }">
        <div>
          <span
            :class="{
              'two-lines ellipse profile-priority-width':isProfileTab,
              'two-lines ellipse approval-priority-width': !isProfileTab
            }"
          >
            {{ item.priority.name }}
          </span>
        </div>
      </template>
      
      <template v-slot:item.task_category.name="{ item }">
        <div>
          <span
            :class="{
              'two-lines ellipse profile-category-width':isProfileTab,
              'two-lines ellipse approval-category-width': !isProfileTab
            }"
          >
            {{ item.task_category.name }}
          </span>
        </div>
      </template>

      <template v-slot:item.due_date="{ item }">
        <div>
          <span v-if="item.due_date">
            {{ $moment(item.due_date).format('DD-MM-YYYY') }}
          </span>
          <span v-else>
            N/A
          </span>
        </div>
      </template>

      <template v-slot:item.created_at="{ item }">
        <div>
          <span>
            {{ $moment(item.created_at).format('DD-MM-YYYY') }}
          </span>
        </div>
      </template>

      <template v-slot:item.action="{ item }"> 
        <task-dialog-all-task-view
          :task="item"
          @updated="loadAllTasks"
        />
      </template>
    </v-data-table>

    <v-container
      v-if="finishLoading && allTasks.length>0"
      class="text-right"
    >
      <v-btn
        icon
        color="primary"
        :disabled="pageNumber === 1"
        @click="previousPage"
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <span class="pagination">{{ from }}-{{ to }} of {{ total }}</span>
      <v-btn
        icon
        color="primary"
        :disabled="pageNumber === lastPage"
        @click="nextPage"
      >
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-container>
  </v-container>
</template>

<script>
  export default {
    components: {
      TaskDialogAllTaskView: () => import('@/components/task/DialogAllTaskView'),
    },
    props: {
      isProfileTab: {
        type: Boolean,
      },
    },

    data () {
      return {
        allTaskHeader: [
          {
            text: 'Task',
            sortable: false,
            align: 'left',
            value: 'content',
          },
          {
            text: 'Owner',
            sortable: false,
            align: 'left',
            value: 'owner.person.name',
          },
          { 
            text: 'Assignee(s)',
            sortable: false,
            align: 'left',
            value: 'assignee_names',
          },
          { 
            text: 'Viewer(s)',
            sortable: false,
            align: 'left',
            value: 'viewer_names',
          },
          { 
            text: 'Status',
            align: 'center',
            value: 'task_status.name',
          },
          { 
            text: 'Priority',
            align: 'center',
            value: 'priority.name',
          },
          { 
            text: 'Category',
            align: 'center',
            value: 'task_category.name',
          },
          { 
            text: 'Due Date',
            align: 'center',
            value: 'due_date',
            width: 140,
          },
          { 
            text: 'Created On',
            align: 'center',
            value: 'created_at',
            width: 140,
          },
          {
            text: '',
            sortable: false,
            align: 'center',
            value: 'action',
          },
        ],
        status: [],
        statusFilterId: 100,
        loading: false,
        allTasks: [],
        pageNumber: 0,
        total: 0,
        from: 0,
        to: 0,
        lastPage: 0,
        finishLoading: false,
        search: '',
      }
    },

    watch: {
      statusFilterId: function (value) {
        if (value) {
          this.loadAllTasks()
        }
      },

      search: function (value) {
        if (value) {
          this._searchTimerId = setTimeout(() => {
            if (value) {
              this.loadAllTasks()
            } else {
              this.loadAllTasks()
            }
          }, 1000) /* 1000ms throttle */
        }
      },
    },

    created () {
      this.loadApprovalStatus()
      this.loadAllTasks()
    },

    methods: {
      loadApprovalStatus () {
        this.$api.approvalStatus().list()
          .then(res => {
            this.status = res.data.filter(item => {
              if (item.id === 200) {
                item.name = 'Closed'
              } else if (item.id === 204) {
                item.id = 199
                item.name = 'Awaiting Approval'
              }

              return item.id !== 502 && item.id !== 201 && item.id !== 500
            })
          })
      },
      
      loadAllTasks () {
        this.loading = true

        this.$api.allTasks().list('', this.prepareFormData())
          .then(res => {
            this.allTasks = []
            this.getAllTaskStatus(res.data.data)
            this.setPaginationDetails(res.data)
            this.finishLoading = true
            this.loading = false
          })
      },

      previousPage () {
        this.loading = true

        this.$api.allTasks().list('?page=' + (this.pageNumber - 1), this.prepareFormData())
          .then(res => {
            this.getAllTaskStatus(res.data.data)
            this.setPaginationDetails(res.data)
            this.finishLoading = true
            this.loading = false
          })
      },

      nextPage () {
        this.loading = true

        this.$api.allTasks().list('?page=' + (this.pageNumber + 1), this.prepareFormData())
          .then(res => {
            this.allTasks = []
            this.getAllTaskStatus(res.data.data)
            this.setPaginationDetails(res.data)
            this.finishLoading = true
            this.loading = false
          })
      },

      getAllTaskStatus (tasks) {
        let temp = []

        tasks.map(task => {
          const taskStatus = task.approval_request.approvals.length > 0 ? _.orderBy(task.approval_request.approvals, ['created_at'], ['desc'])[0].status : { id: 100, name: 'Pending' }
          const assigneeName = this.getAssigneeName(task.assignees)
          const viewerName = this.getViewerName(task.viewers) 

          temp.push({
            ...task,
            assignee_names: assigneeName,
            viewer_names: viewerName,
            task_status: taskStatus,
          })

          temp.map(task => {
            if (task.task_status.id === 502) { // to show pending status
              task.task_status.id = 100
              task.task_status.name = 'Pending'
            } else if (task.task_status.id === 204) {
              task.task_status.id = 199 // for sorting according to status
              task.task_status.name = 'Awaiting Approval'
            } else if (task.task_status.id === 200) {
              task.task_status.name = 'Closed'
            }

            task.comment_scroll_id = task.id + '-' + task.owner_uid + '-comment-scroll'
            task.approval_scroll_id = task.id + '-' + task.owner_uid + '-approval-scroll'
            task.task_scroll_id = task.id + '-' + task.owner_uid + '-task-scroll'

            task.rated = true
            task.assignees.map(assignee => {
              if (!assignee.rating) {
                task.rated = false 
              }
            })
          })
          
          this.allTasks = _.orderBy(temp, ['task_status.id', 'created_at'], ['asc', 'desc'])
        })
      },

      getAssigneeName (assignees) {
        let name = ''
        assignees.map(assignee => {
          name += assignee.employee.person.name + ', '
        })
        return name.substring(0, name.length - 2)
      },

      getViewerName (viewers) {
        let name = ''
        viewers.map(viewer => {
          name += viewer.employee.person.name + ', '
        })
        return name.substring(0, name.length - 2)
      },

      setPaginationDetails (page) {
        this.pageNumber = page.current_page
        this.total = page.total
        this.from = page.from
        this.to = page.to
        this.lastPage = page.last_page
      },

      prepareFormData () {
        return {
          filter: this.statusFilterId,
          searchInput: this.search,
        }
      },
    },
  }
</script>

<style scoped>
.two-lines {
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.ellipse{
  overflow: hidden;
  text-overflow: ellipsis;
}
.profile-content-width{
  width:200px;
}
.approval-content-width{
  width:350px;
}
.profile-name-width{
  width:140px;
}
.approval-name-width{
  width:120px;
}
.approval-name-width{
  width:120px;
}
.profile-status-width{
  width:130px;
}

.profile-priority-width{
  width:80px;
}
.approval-priority-width{
  width:80px;
}
.approval-category-width{
  width:100px;
}
.profile-category-width{
  width:100px;
}
.all-task-table >>> ::-webkit-scrollbar {
  height: 6px; 
  width: 3px !important; 
}
/* Track */
.all-task-table >>> ::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px #e6e6e6; 
  border-radius: 10px;
}
/* Handle */
.all-task-table >>> ::-webkit-scrollbar-thumb {
  background: grey; 
  border-radius: 10px;
  height: 2px;
}
/* Handle on hover */
.all-task-table >>> ::-webkit-scrollbar-thumb:hover {
  background:  #555; 
}
</style>
